import loginDialog from './loginDialog';
import dialogBox from './dialogBox';
import editSubscriber from './editSubscriber';
import openMember from './openMember';

const components = {
  install: function (Vue) {
    Vue.component('loginDialog', loginDialog);
    Vue.component('dialogBox', dialogBox);
    Vue.component('editSubscriber', editSubscriber);
    Vue.component('openMember', openMember);
  }
};

export {
  components
}